export const percentFormat = (value, decimal) =>
  new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: (decimal) ? decimal : 3
  }).format(value/100);
